export const asyncWait = (delayInMilliseconds: number) =>
    new Promise((resolve) => setTimeout(resolve, delayInMilliseconds));
